import { Component, OnInit, ViewChild } from '@angular/core';
import {ApiService} from '../../../shared/services/api.service';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {Contact} from '../../../entities';
import {JhiLanguageService} from 'ng-jhipster';
import {PrivacyPolicyAgreement} from '../../../entities/privacy-policy-agreement.model';
import {PrivacyPolicy} from '../../../entities/privacy-policy.model';
import {API_SERVER} from '../../../app.constants';
import { DeviceRefund } from '../../../entities/device-refund.model';
import { deserialize } from 'json-typescript-mapper';
import { User } from '../../../entities/user.model';
import { TRAINING } from '../../../app.constants';

@Component({
  selector: 'app-employy-detail',
  templateUrl: './employee-detail.component.html',
  styles: []
})
export class EmployeeDetailComponent implements OnInit {

  @ViewChild('resetPasswordFinishModal') private resetPasswordFinishModal;
  @ViewChild('deativateUserModal') private deativateUserModal;
  @ViewChild('resetPasswordModal') private resetPasswordModal;
  documentUrl: string = API_SERVER + 'documents';
  private modalRef: any = null;
  loadingIndicator = true;
  employeeId: number;
  employee: Contact;
  privacyPolicyAgreements: PrivacyPolicyAgreement[];
  newestActivePrivacyPolicyAgreement: PrivacyPolicyAgreement;
  privacyPolicies: PrivacyPolicy[];
  activePrivacyPolicies: PrivacyPolicy[];
  newestActivePrivacyPolicy: PrivacyPolicy;
  userHasAcceptedNewestActivePrivacyPolicy = false;
  deactivateReason: string;
  newPassword: string;
  inputTypePassword = 'password';
  deviceRefunds: Array<DeviceRefund>;
  currentDeviceRefund: DeviceRefund;
  deviceRefundActive: boolean;
  deviceRefundComment = '';
  updateTrainingInfoText;
  trainingSystem = TRAINING;

  constructor(
    private apiService: ApiService,
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private jhiLanguageService: JhiLanguageService,
  ) {
    this.jhiLanguageService.setLocations(['employee']);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.employeeId = +params['id'];
      this.loadEmployee(this.employeeId);
    });
  }

  loadEmployee(employeeId) {
    this.apiService.findOne<Contact>(Contact, 'contacts/' + employeeId).subscribe(
      contact => {
        this.employee = contact;
        if (contact.user) {
          Promise.all([
            this.getPrivacyPolicies(),
            this.getActivePrivacyPolicy(),
            this.getPrivacyPolicyAgreements(contact.user.id),
            this.getDeviceRefunds(contact.user.id)
          ])
            .then(() => {
              this.privacyPolicyAgreements.forEach((privacyPolicyAgreement, index) => {
                if (privacyPolicyAgreement.privacyPolicy.id === this.newestActivePrivacyPolicy.id) {
                  this.userHasAcceptedNewestActivePrivacyPolicy = true;
                  this.newestActivePrivacyPolicyAgreement = this.privacyPolicyAgreements[index];
                }
              });
              this.loadingIndicator = false;
            });
        } else {
          this.loadingIndicator = false;
          // // console.log('userHasAcceptedNewestActivePrivacyPolicy', this.userHasAcceptedNewestActivePrivacyPolicy);
        }
      }
    );
  }

  isMarketMaster() {
    return this.employee.category === 'Mitarbeiter | Marktmeister';
  }

  getPrivacyPolicyAgreements(userId) {
    return new Promise(resolve => {
      this.apiService.find<PrivacyPolicyAgreement>(PrivacyPolicyAgreement, 'privacy-policy-agreements-by-user/' + userId).subscribe(
        privacyPolicyAgreementRes => {
          this.privacyPolicyAgreements = privacyPolicyAgreementRes as PrivacyPolicyAgreement[];
          // console.log('this.privacyPolicyAgreements', this.privacyPolicyAgreements);
          resolve();
        });
    });
  }

  getDeviceRefunds(userId) {
    return new Promise(resolve => {
      this.apiService.find<DeviceRefund>(DeviceRefund, 'device-refunds-by-user/' + userId)
        .subscribe((deviceRefunds: Array<DeviceRefund>) => {
          this.deviceRefunds = deviceRefunds;
          if (!this.deviceRefunds || this.deviceRefunds.length === 0) {
            this.currentDeviceRefund = new DeviceRefund();
            this.currentDeviceRefund.id = null;
            this.currentDeviceRefund.refundPerMerchant = 0.02;
            this.currentDeviceRefund.marketdateRefund = 0.25;
            this.currentDeviceRefund.validFrom = new Date(0).toString();
            this.currentDeviceRefund.user = this.employee.user;
          } else {
            console.log('not sorted:', deviceRefunds);

            const sorted = deviceRefunds
            .sort((a, b) => {
              const aValidDate = new Date(a.validFrom).getTime();
              const bValidDate = new Date(b.validFrom).getTime();
              if (aValidDate > bValidDate) {
                return -1;
              } else if (aValidDate < bValidDate) {
                return 1;
              } else if (aValidDate === bValidDate) {
                if (a.id > b.id) {
                  return -1;
                } else if (a.id < b.id) {
                  return 1;
                } else {
                  return 0;
                }
              }
            });
            console.log('sorted:', sorted);
            this.currentDeviceRefund = sorted[0];
          }
          this.deviceRefundActive = this.currentDeviceRefund.marketdateRefund > 0
            || this.currentDeviceRefund.refundPerMerchant > 0;
          resolve();
        }, error => resolve());
      });
  }

  getPrivacyPolicies() {
    return new Promise(resolve => {
      this.apiService.find<PrivacyPolicy>(PrivacyPolicy, 'privacy-policies')
        .subscribe(privacyPolicies => {
          this.privacyPolicies = privacyPolicies as PrivacyPolicy[];
          // console.log('this.privacyPolicies', this.privacyPolicies);
          resolve();
        });
    });
  }

  getActivePrivacyPolicy() {
    return new Promise(resolve => {
      this.apiService.find<PrivacyPolicy>(PrivacyPolicy, 'privacy-policies-active/').subscribe(
        activePrivacyPolicy => {
          this.activePrivacyPolicies = activePrivacyPolicy as PrivacyPolicy[];
          const sortedAPPs = this.activePrivacyPolicies.sort((a, b) => {
            return new Date(a.created).getTime() - new Date(b.created).getTime();
          });
          this.newestActivePrivacyPolicy = sortedAPPs[sortedAPPs.length - 1];
          // console.log('this.activePrivacyPolicies', this.activePrivacyPolicies);
          // console.log('this.newestActivePrivacyPolicy', this.newestActivePrivacyPolicy);
          resolve();
        }
      );
    });
  }

  isPrivacyPolicyAccepted(privacyPolicyId) {
    let result = null;
    this.privacyPolicyAgreements.forEach((privacyPolicyAgreement, index) => {
      if (privacyPolicyAgreement.privacyPolicy.id === privacyPolicyId) {
        result = this.privacyPolicyAgreements[index];
      }
    });
    return result;
  }

  createUser() {
    this.modalRef.close();
    this.loadingIndicator = true;
    this.apiService.postRegular(null, 'user-from-contact/' + this.employee.id)
      .subscribe(createUserResponse => {
        console.log('createUserResponse', createUserResponse);
        this.loadEmployee(this.employeeId);
    }, error => {
        console.log('error create user from contact', error);
        this.loadingIndicator = false;
    });
  }

  activateUser() {
    this.modalRef.close();
    this.loadingIndicator = true;
    this.apiService.get('activate-user/' + this.employee.user.id)
      .subscribe(activateUserResponse => {
        console.log('activateUserResponse', activateUserResponse);
        this.loadEmployee(this.employeeId);
    }, error => {
        console.log('error activate user', error);
        this.loadingIndicator = false;
    });
  }

  deactivateUser() {
    this.modalRef.close();
    this.loadingIndicator = true;

    const userDeactivateReason = {
      id: null,
      created: new Date(),
      updated: new Date(),
      reason: (this.deactivateReason !== null && this.deactivateReason !== '') ? this.deactivateReason : null,
      user: this.employee.user
    };

    this.apiService.postRegular(userDeactivateReason, 'deactivate-user-with-reason/' + this.employee.user.id)
      .subscribe(deactivateUserResponse => {
        console.log('deactivateUserResponse', deactivateUserResponse);
        this.loadEmployee(this.employeeId);
    }, error => {
        console.log('error deactivate user', error);
        this.loadingIndicator = false;
    });
  }

  toggleSmartphoneRefund() {
    this.modalRef.close();
    this.loadingIndicator = true;
    const newDeviceRefund = new DeviceRefund();
    newDeviceRefund.id = null;
    newDeviceRefund.user = this.employee.user;
    newDeviceRefund.validFrom =
      new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 0)
        .toISOString();
    newDeviceRefund.marketdateRefund = (this.deviceRefundActive) ? 0 : 0.25;
    newDeviceRefund.refundPerMerchant = (this.deviceRefundActive) ? 0 : 0.02;
    newDeviceRefund.comment = (this.deviceRefundComment) ? this.deviceRefundComment : null;
    this.apiService.post(newDeviceRefund, 'device-refunds').subscribe(postResult => {
      this.currentDeviceRefund = deserialize<DeviceRefund>(DeviceRefund, postResult.json());
      this.deviceRefundActive = this.currentDeviceRefund.marketdateRefund > 0
        || this.currentDeviceRefund.refundPerMerchant > 0;
      this.deviceRefundComment = '';
      this.loadingIndicator = false;
    }, e => {
      console.log('error posting devicerefund:', e);
      this.loadingIndicator = false;
    });
  }

  saveNewPassword() {
    this.modalRef.close();
    this.loadingIndicator = true;

    const resetUserPasswordBody = {key: null, newPassword: this.newPassword};

    this.apiService.postRegular(resetUserPasswordBody, 'reset-user-password/' + this.employee.user.id)
      .subscribe(resetUserPasswordResponse => {
        console.log('resetUserPasswordResponse', resetUserPasswordResponse);
        this.loadEmployee(this.employeeId);
        this.newPassword = null;
        this.openModal(this.resetPasswordFinishModal);
      }, error => {
        console.log('error reset user password:', error);
        this.loadingIndicator = false;
        this.newPassword = null;
      });
  }

  openModal(modal: any, options: NgbModalOptions = {}) {
    this.modalRef = this.modalService.open(modal, options);
  }

  showTrainingToggle(): boolean {
    return this.employee.category === 'Mitarbeiter | Marktmeister';
  }

  changeTraining() {
    this.updateTrainingInfoText = '<i class="fa fa-spinner fa-spin"></i>&nbsp;Lade ...';
    this.apiService.findOne<User>(User, ['toggle-user-training', this.employee.user.id, this.employee.user.training].join('/'))
      .subscribe((updatedUser: User) => {
        this.updateTrainingInfoText = '<i class="fa fa-check text-success"></i>&nbsp;Gespeichert!';
        setTimeout(() => this.updateTrainingInfoText = null, 2000);
      }, error => {
        this.employee.user.training = !this.employee.user.training;
        this.updateTrainingInfoText = '<i class="fa fa-times text-danger"></i>&nbsp;Es ist ein Fehler aufgetreten!';
        setTimeout(() => this.updateTrainingInfoText = null, 2000);
      });
  }

  disableUser() {
    if (!this.trainingSystem) {
      this.deactivateReason = '';
      this.openModal(this.deativateUserModal);
    }
  }

  resetPassword() {
    if (!this.trainingSystem) {
      this.newPassword = '';
      this.openModal(this.resetPasswordModal);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/employee/components/employee-detail/employee-detail.component.ts